import { RED, YELLOW, GREEN } from '../config/colors'
import {
  FLOOD_RIVER_COLORS,
  FLOOD_HAZARD_COLORS,
  RIVER_FLOOD_MONITORING_COLORS,
  LEAK_DETECTION_COLORS,
  NDVI_COLORS,
  PIPELINE_CHANGE_DETECTION_COLORS,
  RIVER_CLASS_COLORS
} from '../layers/paints'

const createLegendValues = colorsList => {
  const legendValues = colorsList
        .filter(item => item.label)
        .map(item => ({ label: item.label, color: item.color }))

  return legendValues
}

export const floodHazardLegend = [
  { label: '0.5m', color: FLOOD_HAZARD_COLORS[0] },
  { label: '1m', color: FLOOD_HAZARD_COLORS[1] },
  { label: '1.5m', color: FLOOD_HAZARD_COLORS[2] },
  { label: '2m', color: FLOOD_HAZARD_COLORS[3] },
  { label: '2.5m', color: FLOOD_HAZARD_COLORS[4] },
  { label: '3m', color: FLOOD_HAZARD_COLORS[5] },
  { label: '3.5m', color: FLOOD_HAZARD_COLORS[6] },
  { label: '4m', color: FLOOD_HAZARD_COLORS[7] },
  { label: '>4m', color: FLOOD_HAZARD_COLORS[8] }
]

export const riverFloodMonitoringLegend = [
  { label: '<10', color: RIVER_FLOOD_MONITORING_COLORS[0] },
  { label: '<20', color: RIVER_FLOOD_MONITORING_COLORS[1] },
  { label: '<30', color: RIVER_FLOOD_MONITORING_COLORS[2] },
  { label: '<40', color: RIVER_FLOOD_MONITORING_COLORS[3] },
  { label: '<50', color: RIVER_FLOOD_MONITORING_COLORS[4] },
  { label: '<60', color: RIVER_FLOOD_MONITORING_COLORS[5] },
  { label: '<70', color: RIVER_FLOOD_MONITORING_COLORS[6] },
  { label: '<80', color: RIVER_FLOOD_MONITORING_COLORS[7] },
  { label: '>=80', color: RIVER_FLOOD_MONITORING_COLORS[8] }
]

export const leakDetectionLegend = [
  { label: '<.75', color: LEAK_DETECTION_COLORS[0] },
  { label: '<.80', color: LEAK_DETECTION_COLORS[1] },
  { label: '<.85', color: LEAK_DETECTION_COLORS[2] },
  { label: '<.90', color: LEAK_DETECTION_COLORS[3] },
  { label: '<.95', color: LEAK_DETECTION_COLORS[4] },
  { label: '<1.0', color: LEAK_DETECTION_COLORS[5] }
]

export const floodRiverClassificationLegend = [
  { label: 'Open/Water', color: FLOOD_RIVER_COLORS[0] },
  { label: 'Smooth', color: FLOOD_RIVER_COLORS[1] },
  { label: 'Rough', color: FLOOD_RIVER_COLORS[2] }
]

export const pipelineGreenLegend = [
  { label: '0', color: '#0000ff' },
  { label: '100', color: '#1bd533' },
  { label: '200', color: '#dae12b' },
  { label: '300', color: '#e98c16' },
  { label: '400', color: '#df5710' }
]

export const polarViewLegend = [
  { label: 'Smooth', color: 'green' },
  { label: 'Rough', color: 'yellow' },
  { label: 'Mobile', color: 'red' }
]

export const smartIceLegend = [
  { label: 'Go', color: 'green' },
  { label: 'Slow go', color: 'yellow' },
  { label: 'No go', color: 'red' }
]

export const smartIceQamutikLegend = [
  { label: '<1 ft', color: 'darkOrange' },
  { label: '2 ft', color: 'orange' },
  { label: '3 ft', color: 'wheat' },
  { label: '5 ft', color: 'powderBlue' },
  { label: '7 ft', color: 'slateBlue' }
]

export const riverIceLegend = [
  { label: 'Water', color: '#044A8F' },
  { label: 'Deterior.', color: '#6BC0E9' },
  { label: 'Smooth', color: '#FAF703' },
  { label: 'Rough', color: '#DC440C' }
]

export const riverIceChurchillLegend = [
  { label: 'Open Water', color: '#044A8F', offsetX: -15, style: { fill: 'white' } },
  { label: 'Water on Ice', color: '#6BC0E9', offsetX: -15 },
  { label: 'Non-Consol.', color: '#FAF703', offsetX: -15 },
  { label: 'Consol', color: '#DC440C', offsetX: -10 }
]

export const iceDriftLegend = [
    { label: '.00', color: '#7676f4' },
    { label: '.10', color: '#0e8f7c' },
    { label: '.20', color: '#50e62c' },
    { label: '.30', color: '#e6fc0c' },
    { label: '.40', color: '#febd09' },
    { label: '.50', color: '#fe870b' },
    { label: '.60', color: '#fb8a7d' }
]

export const cmemsSeaIceLegend = [
  { label: '0%', color: 'blue' },
  { label: '20%', color: 'deepSkyBlue' },
  { label: '50%', color: 'greenYellow' },
  { label: '70%', color: 'orangeRed' },
  { label: '100%', color: 'darkRed' }
]

export const cmemsSnowThicknessLegend = [
  { label: '0m', color: 'blue' },
  { label: '0.5m', color: 'deepSkyBlue' },
  { label: '1m', color: 'greenYellow' },
  { label: '1.5m', color: 'orangeRed' },
  { label: '2m', color: 'darkRed' }
]

export const deformationLegend = [
  { label: '5cm', color: '#00956f' },
  { label: '0cm', color: '#81dc2e' },
  { label: '-5cm', color: '#f6d628' },
  { label: '-10cm', color: '#e98e19' },
  { label: '-15cm', color: '#d11918' }
]

// export const mopraLegend = [
//   { label: '-1.0', color: '#d7191c' },
//   { label: '-0.5', color: '#feb86c' },
//   { label: '0.0', color: '#cbf882' },
//   { label: '0.5 ', color: '#74ce53' },
//   { label: '1.0', color: '#1a9641' }
// ]

export const mopraWellsitesLegend = [
  { label: 'good', color: GREEN },
  { label: 'moderate', color: YELLOW },
  { label: 'poor', color: RED }
]

export const mopraNdviLegend = createLegendValues(NDVI_COLORS)
export const mopraLegend = createLegendValues(NDVI_COLORS)
export const pipelineChangeDetectionLegend = createLegendValues(PIPELINE_CHANGE_DETECTION_COLORS)

// export const mopraNdviLegend = [
//   { label: '-1.0', color: '#d7191c' },
//   { label: '-0.5', color: '#feb86c' },
//   { label: '0.0', color: '#cbf882' },
//   { label: '0.5', color: '#74ce53' },
//   { label: '1.0', color: '#1a9641' }
// ]

export const waterLakeTssLegend = [
  { label: '0', color: '#005ea5' },
  { label: '10', color: '#1bd533' },
  { label: '20', color: '#aade2d' },
  { label: '30', color: '#efb123' },
  { label: '40', color: '#b2670a' },
  { label: '50', color: '#660800' },
  { label: 'cloud', color: '#858585', style: { fill: 'white'}, dx: 30 }
]

export const waterLakeChlLegend = [
  { label: '0', color: '#0000ff' },
  { label: '1500', color: '#5fd930' },
  { label: '3000', color: '#eb9b20' },
  { label: '4500', color: '#b60015' },
  { label: 'cloud', color: '#858585', style: { fill: 'white' } }
]

export const riverTemperatureLegend = [
  { label: '0', color: '#FFFFFF' },
  { label: '10', color: '#82D2FF' },
  { label: '20', color: '#FFE878' },
  { label: '30', color: '#b60015' }
]

export const riverSedimentLegend = [
  { label: '0', color: '#38A800' },
  { label: '100', color: '#AADE00' },
  { label: '200', color: '#FF9100' },
  { label: '300', color: '#FF0800' }
]

export const bathymetricLegend = [
  { label: '1m', color: '#162dfd' },
  { label: '30m', color: '#6ee1f4' },
  { label: '60m', color: '#f8e028' },
  { label: '90m', color: '#ff0c00' }
]



// WEBPACK FOOTER //
// ./src/config/legends.js